import React, { useEffect, useState } from "react";
import style from "./reportListCard.module.scss";
import ThreeDotDropdown from "../../Dropdown/ThreeDotsDropDown/DropDown"
import { Inventory, Pricing, productInfo, RobotData } from "../../../helpers/consts/reportConsts"
import { withRouter } from "react-router-dom"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"

const ReportListCard = (props) => {
    const array = [{
        name: "ویرایش ", onclick: () => {
            props.threeDotHandler("edit", props.data._id)
        }, modalOpen: () => {
        }
    }, {
        name: "حذف", onclick: () => {
            props.threeDotHandler("delete", props.data._id)
        }, modalOpen: () => {
        }
    }]
    const [reportFeatuersList, setReportFeatuersList] = useState([])
    useEffect(() => {
        if (typeof props.data !== "undefined") {
            Object.keys(props.data.show).forEach(item => {
                // console.log(item);
                searchArray(productInfo, item)
                searchArray(Pricing, item)
                searchArray(Inventory, item)
                searchArray(RobotData, item)
            })
        }


    }, [props.data.show])
    const searchArray = (array, key) => {
        let temp = reportFeatuersList;
        array.map(item => {
            if (item.value == key) {
                let index = temp.findIndex(i => i === item.name)
                // console.log(item.name,"hi");
                if (index < 0) {
                    temp.push(item.name);
                }
            }
        });
        // console.log(temp);
        setReportFeatuersList([...temp])

    }
    // console.log(props.data,"ppppp");
    return (
        <div className={style.wrapper}>
            <div className={style.row}>
                <h3>{toPersianNumber(props.data.reportName)}</h3>
                <div className={style.threeDotWrapper}>
                    <ThreeDotDropdown items={array} isLeft={true} />
                </div>
            </div>
            <p>{reportFeatuersList.join(', ')}</p>
            <div className={style.showReportButton}
                onClick={(e) => props.history.push({
                    pathname: "/report/show/" + props.data._id,
                    state: { report: { ...props.data } }
                }
                )}>مشاهده گزارش
            </div>
        </div>
    )


}

export default withRouter(ReportListCard);
